module.exports = __webpack_public_path__ + "img/dashboards 3.67c18003.png";